export const inspectionRequiredFields = {
  phone: false,
  firstName: true,
  lastName: true,
  inspectionDate: true,
  insuranceDate: false,
  workerSelect: true
};
